// Traduções em nível de página - Português (Brasil)
export const pagesPt = {
  home: {
    title: 'Início',
    description: 'Descubra veículos de qualidade e atendimento personalizado.',
  },
  vehicles: {
    title: 'Veículos',
    found: 'veículos encontrados',
    searchPlaceholder: 'Buscar por marca, modelo ou ano...',
    noResults: 'Nenhum veículo encontrado',
    noResultsDescription: 'Tente ajustar os filtros ou critérios de busca',
    orderBy: 'Ordenar por',
  },
  vehicleDetails: {
    loading: 'Carregando detalhes do veículo...',
    notFound: 'Veículo não encontrado',
    backToVehicles: 'Voltar para veículos',
  },
  financing: {
    title: 'Financiamento',
    subtitle: 'Opções flexíveis para você',
    description:
      'Conte com os melhores planos de financiamento, com taxas competitivas e aprovação rápida.',
  },
  consignments: {
    title: 'Consignação',
    subtitle: 'Venda seu carro com a gente',
    description:
      'Cuidamos de todo o processo de venda para você obter o melhor valor.',
  },
  buyDirect: {
    title: 'Compramos seu carro',
    subtitle: 'Compra rápida e segura',
    description:
      'Receba uma oferta imediata e venda seu carro com confiança.',
  },
  weSearchForYou: {
    title: 'Buscamos para você',
    subtitle: 'Conte para a gente o que você precisa',
    description:
      'Descreva seu veículo ideal e encontraremos as melhores opções.',
  },
};
